import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api } from "@/lib/api";
import { errMsg } from "@/lib/download";

const when = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });
const STATUS = { open: ["Da rispondere", "bg-red-100 text-red-700"], answered: ["Risposta inviata", "bg-emerald-100 text-emerald-700"], closed: ["Chiusa", "bg-slate-100 text-slate-600"] };

const Request = ({ r, onDone }) => {
  const [text, setText] = useState("");
  const reply = async (e) => {
    e.preventDefault();
    try { await api.post(`/admin/support/help/${r.id}/reply`, { text }); setText(""); toast.success("Risposta inviata all'utente"); onDone(); } catch (err) { toast.error(errMsg(err)); }
  };
  const close = async () => { await api.post(`/admin/support/help/${r.id}/status/closed`); onDone(); };
  const [label, cls] = STATUS[r.status];
  return (
    <div className="card-premium p-5" data-testid={`support-req-${r.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><b data-testid={`support-req-name-${r.id}`}>{r.userName}</b> <span className="text-xs text-slate-500">· {r.roleLabel} · {r.email} · {when(r.createdAt)}</span></div>
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${cls}`}>{label}</span>
      </div>
      <p className="mt-2 text-sm whitespace-pre-line" data-testid={`support-req-msg-${r.id}`}>{r.message}</p>
      {r.replies.map((x, i) => <div key={i} className="mt-2 pl-3 border-l-2 border-gold text-sm"><div className="text-xs text-slate-500">Risposta · {when(x.at)}</div>{x.text}</div>)}
      {r.status !== "closed" && <form onSubmit={reply} className="mt-3 flex flex-col sm:flex-row gap-2">
        <textarea required minLength={5} rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi la risposta (l'utente riceve una notifica)" data-testid={`support-reply-text-${r.id}`} className="flex-1 border border-slate-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-gold"/>
        <div className="flex sm:flex-col gap-2"><button disabled={text.trim().length < 5} data-testid={`support-reply-send-${r.id}`} className="btn-pill-gold text-xs disabled:opacity-50"><Send className="w-3.5 h-3.5"/>Rispondi</button>
          <button type="button" onClick={close} data-testid={`support-close-${r.id}`} className="btn-pill-outline text-xs">Chiudi</button></div>
      </form>}
    </div>
  );
};

export const SupportSection = () => {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/support/help").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  if (!items) { return null; }
  return (
    <div className="space-y-4" data-testid="admin-support">
      <h2 className="font-display text-2xl font-bold">Richieste di supporto <span className="text-base text-slate-500">({items.filter((r) => r.status === "open").length} da rispondere)</span></h2>
      {items.length === 0 ? <p className="text-sm text-slate-500">Nessuna richiesta.</p> : items.map((r) => <Request key={r.id} r={r} onDone={load}/>)}
    </div>
  );
};

export const SuggestionsSection = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/support/suggestions").then((r) => setItems(r.data)); }, []);
  if (!items) { return null; }
  return (
    <div className="space-y-3" data-testid="admin-suggestions">
      <h2 className="font-display text-2xl font-bold">Suggerimenti degli utenti</h2>
      {items.length === 0 ? <p className="text-sm text-slate-500">Nessun suggerimento.</p> : items.map((s) => (
        <div key={s.id} className="card-premium p-4" data-testid={`suggestion-${s.id}`}>
          <div className="text-xs text-slate-500"><b className="text-aic-navy">{s.userName}</b> · {s.roleLabel} · {when(s.createdAt)}</div>
          <p className="text-sm mt-1 whitespace-pre-line">{s.text}</p>
        </div>
      ))}
    </div>
  );
};
